import { getContinue, getSubmitForm } from 'lib/actions';

export const defaultActionsTemplate = ({ elementId }) => ({
  [elementId]: [getContinue()],
});

export const defaultActionsWithSubmitTemplate = ({ elementId }) => ({
  [elementId]: [getSubmitForm(), getContinue()],
});
